import {
  Book, Target, GraduationCap, Magnet, UserCheck, ClipboardList,
  CalendarDays, Calculator, Utensils, Dumbbell, CheckSquare, Briefcase,
  PiggyBank, BookOpen, Images, FileText, Notebook, CookingPot, Baby,
  Plane, Lightbulb, PawPrint, HeartPulse
} from 'lucide-react';

export const productTypeConfig = [
  { id: 'ebook', name: 'E-book', icon: Book, desc: 'Chapters, table of contents, summary', category: 'Content' },
  { id: 'goal-workbook', name: 'Workbook', icon: Target, desc: 'Reflection, exercises, fill-in fields', category: 'Workbook' },
  { id: 'course-booklet', name: 'Course booklet', icon: GraduationCap, desc: 'Modulees, learning objectives, exercises', category: 'Course' },
  { id: 'lead-magnet', name: 'Lead Magnet', icon: Magnet, desc: 'Short, visual, conversion-focused', category: 'Marketing' },
  { id: 'client-guide', name: 'Client guide', icon: UserCheck, desc: 'Before/after info, FAQ, advice', category: 'Service' },
  { id: 'checklist', name: 'Checklist', icon: ClipboardList, desc: 'Simple, clear, action-oriented', category: 'Tools' },
  { id: 'daily-planner', name: 'Daily planner', icon: CalendarDays, desc: 'Daily productivity and journal', category: 'Planner' },
  { id: 'budget-planner', name: 'Budget planner', icon: Calculator, desc: 'Financial planning and tracking', category: 'Planner' },
  { id: 'meal-planner', name: 'Meal planner', icon: Utensils, desc: 'Weekly menus and shopping lists', category: 'Planner' },
  { id: 'workout-planner', name: 'Workout program', icon: Dumbbell, desc: 'Training plans and progression', category: 'Planner' },
  { id: 'habit-tracker', name: 'Habit tracker', icon: CheckSquare, desc: 'Daily habit tracking', category: 'Planner' },
  { id: 'business-planner', name: 'Business plan', icon: Briefcase, desc: 'Strategy and goals for business', category: 'Business' },
  { id: 'savings-tracker', name: 'Savings goal', icon: PiggyBank, desc: 'Track your savings goals', category: 'Planner' },
  { id: 'guide', name: 'Digital guide', icon: BookOpen, desc: 'Comprehensive content guides', category: 'Content' },
  { id: 'carousel', name: 'Instagram carousel', icon: Images, desc: 'Multi-slide posts', category: 'Social' },
  { id: 'printable', name: 'Printable', icon: FileText, desc: 'Printable sheets and pages', category: 'Tools' },
  { id: 'journal', name: 'Journal', icon: Notebook, desc: 'Diary with prompts, gratitude and reflection', category: 'Journal' },
  { id: 'recipe-book', name: 'Recipe book', icon: CookingPot, desc: 'Recipes with ingredients, instructions and shopping list', category: 'Book' },
  { id: 'memory-book', name: 'Memory book', icon: Baby, desc: 'Milestones, photo pages, letters and memories', category: 'Memory book' },
  { id: 'travel-planner', name: 'Travel planner', icon: Plane, desc: 'Itinerary, packing list, budget and destination info', category: 'Planner' },
  { id: 'fitness-program', name: 'Fitness program', icon: Dumbbell, desc: 'Structured sessions with progression and exercise library', category: 'Fitness' },
  { id: 'activity-book', name: 'Activity book', icon: Lightbulb, desc: 'Creative tasks, challenges, games and certificates', category: 'Activity book' },
  { id: 'reading-journal', name: 'Reading journal', icon: BookOpen, desc: 'Book reviews, reading list, quotes and reading log', category: 'Journal' },
  { id: 'pet-journal', name: 'Pet journal', icon: PawPrint, desc: 'Health log, milestones, training diary and memories', category: 'Journal' },
  { id: 'pregnancy-journal', name: 'Pregnancy journal', icon: HeartPulse, desc: 'Week-by-week, milestones, letters to baby', category: 'Journal' },
];

export const contentStructureTemplates = {
  'ebook': [
    { title: 'Table of Contents', desc: 'Overview of all chapters' },
    { title: 'Introduction', desc: 'Background, purpose and who the book is for' },
    { title: 'Chapter 1', desc: 'Fundamental concepts and principles' },
    { title: 'Chapter 2', desc: 'Practical steps and strategies' },
    { title: 'Chapter 3', desc: 'Advanced techniques and tips' },
    { title: 'Chapter 4', desc: 'Common mistakes and how to avoid them' },
    { title: 'Summary', desc: 'Key takeaways and next steps' },
    { title: 'Resources', desc: 'Links, tools and further reading' },
    { title: 'About the Author', desc: 'Short bio and contact information' },
  ],
  'goal-workbook': [
    { title: 'Welcome', desc: 'Introduction and how to use the workbook' },
    { title: 'Self-Assessment', desc: 'Map where you stand now' },
    { title: 'Reflection', desc: 'Reflection questions and self-analysis' },
    { title: 'Exercise 1', desc: 'Practical exercise with fill-in fields' },
    { title: 'Exercise 2', desc: 'Deep-dive exercise with examples' },
    { title: 'Exercise 3', desc: 'Creative exercise with open answers' },
    { title: 'Action Plan', desc: 'Concrete steps and deadlines' },
    { title: 'Progress Tracker', desc: 'Track progress over time' },
    { title: 'Conclusion', desc: 'Summary and motivation' },
  ],
  'course-booklet': [
    { title: 'Course Overview', desc: 'Goals, content and expected outcomes' },
    { title: 'Modulee 1: Foundation', desc: 'Introduction and core concepts' },
    { title: 'Modulee 2: Deep Dive', desc: 'Detailed walkthrough and examples' },
    { title: 'Modulee 3: Practice', desc: 'Practical exercises and case studies' },
    { title: 'Modulee 4: Mastery', desc: 'Advanced techniques and customization' },
    { title: 'Assignments', desc: 'Questions and exercises for each module' },
    { title: 'Summary', desc: 'Key points and learning objectives achieved' },
    { title: 'Certificate', desc: 'Diploma/certificate for completed course' },
  ],
  'lead-magnet': [
    { title: 'Title Page', desc: 'Catchy headline and value proposition' },
    { title: 'The Problem', desc: 'Describe the challenge the reader has' },
    { title: 'Quick Win 1', desc: 'First actionable tip with immediate value' },
    { title: 'Quick Win 2', desc: 'Second practical tip' },
    { title: 'Quick Win 3', desc: 'Third valuable insight' },
    { title: 'About Me', desc: 'Brief about you and your expertise' },
    { title: 'Next Steps', desc: 'Call-to-action and further offers' },
  ],
  'client-guide': [
    { title: 'Welcome', desc: 'Welcome message and overview' },
    { title: 'Before Treatment', desc: 'Preparations and what to know' },
    { title: 'What to Expect', desc: 'Step-by-step through the process' },
    { title: 'Aftercare', desc: 'Care and follow-up advice' },
    { title: 'FAQ', desc: 'Common questions with answers' },
    { title: 'Tips & Advice', desc: 'Extra tips for best results' },
    { title: 'Contact', desc: 'Booking, hours and contact info' },
  ],
  'checklist': [
    { title: 'Overview', desc: 'What the checklist covers and how to use it' },
    { title: 'Category 1', desc: 'First group of tasks' },
    { title: 'Category 2', desc: 'Second group of tasks' },
    { title: 'Category 3', desc: 'Third group of tasks' },
    { title: 'Timeline', desc: 'When tasks should be completed' },
    { title: 'Notes', desc: 'Space for your own notes' },
  ],
  'daily-planner': [
    { title: 'Daily Overview', desc: 'Morning blocking and priorities' },
    { title: 'Time Blocks', desc: 'Hour-by-hour planning' },
    { title: 'To-Do List', desc: 'Today\'s tasks with priority' },
    { title: 'Notes', desc: 'Free notes and ideas' },
    { title: 'Reflection', desc: 'Evening review and gratitude' },
  ],
  'budget-planner': [
    { title: 'Monthly Overview', desc: 'Income, expenses and balance' },
    { title: 'Fixed Expenses', desc: 'Rent, insurance, subscriptions' },
    { title: 'Variable Expenses', desc: 'Food, transport, entertainment' },
    { title: 'Savings Goal', desc: 'Goals and progression' },
    { title: 'Weekly Tracking', desc: 'Day-by-day expense log' },
  ],
  'meal-planner': [
    { title: 'Weekly Menu', desc: 'Monday to Sunday with all meals' },
    { title: 'Shopping List', desc: 'Categorized grocery list' },
    { title: 'Recipes', desc: 'Selected recipes for the week' },
    { title: 'Nutrition Info', desc: 'Macros and calorie counts' },
    { title: 'Meal Prep Guide', desc: 'Preparation tips for the week' },
  ],
  'workout-planner': [
    { title: 'Program Overview', desc: 'Goals, duration and level' },
    { title: 'Week 1-2', desc: 'Startup phase with basic exercises' },
    { title: 'Week 3-4', desc: 'Progression and intensity' },
    { title: 'Exercise Library', desc: 'Description of all exercises' },
    { title: 'Progress Tracker', desc: 'Log weights and repetitions' },
  ],
  'habit-tracker': [
    { title: '30-Day Overview', desc: 'Visual grid for the whole month' },
    { title: 'My Habits', desc: 'Define the habits you want to build' },
    { title: 'Daily Log', desc: 'Mark completed habits' },
    { title: 'Weekly Reflection', desc: 'What went well and what can improve' },
    { title: 'Reward System', desc: 'Milestones and rewards' },
  ],
  'business-planner': [
    { title: 'Business Idea', desc: 'Vision, mission and value proposition' },
    { title: 'Market Analysis', desc: 'Target audience and competitors' },
    { title: 'Strategy', desc: 'Go-to-market and growth plan' },
    { title: 'Finances', desc: 'Budget, pricing and revenue goals' },
    { title: 'Action Plan', desc: 'Concrete tasks and deadlines' },
  ],
  'savings-tracker': [
    { title: 'Savings Goal', desc: 'Define amount and deadline' },
    { title: 'Monthly Tracking', desc: 'Deposits and balance per month' },
    { title: 'Visual Progress', desc: 'Graphical display of progress' },
    { title: 'Savings Challenge', desc: 'Weekly or monthly challenge' },
    { title: 'Milestones', desc: 'Celebrate sub-goals along the way' },
  ],
  'guide': [
    { title: 'Introduction', desc: 'Overview and who the guide is for' },
    { title: 'Step 1', desc: 'First phase with explanations' },
    { title: 'Step 2', desc: 'Second phase with practical tips' },
    { title: 'Step 3', desc: 'Third phase with advanced content' },
    { title: 'Tools & Resources', desc: 'Recommended tools and links' },
    { title: 'Conclusion', desc: 'Summary and next steps' },
  ],
  'carousel': [
    { title: 'Cover Slide', desc: 'Catchy title and visual first impression' },
    { title: 'Slides 2-7', desc: 'Content slides with tips and information' },
    { title: 'CTA Slide', desc: 'Closing with call to action' },
  ],
  'printable': [
    { title: 'Title Page', desc: 'Visual cover with title' },
    { title: 'Content', desc: 'Main content of the printable' },
    { title: 'Instructions', desc: 'How to use the sheet' },
  ],
  'journal': [
    { title: 'Introduction', desc: 'Welcome and how to use the journal' },
    { title: 'Daily Journal Page', desc: 'Date, mood, gratitude, reflection' },
    { title: 'Daily Journal Page 2', desc: 'Second daily page with new prompts' },
    { title: 'Gratitude Page', desc: 'Three things I am grateful for today' },
    { title: 'Writing Prompt', desc: 'Deep reflection question with writing space' },
    { title: 'Writing Prompt 2', desc: 'Creative thought question' },
    { title: 'Weekly Summary', desc: 'Week\'s highlights, challenges and lessons' },
    { title: 'Goal Setting', desc: 'Short-term and long-term goals with action plan' },
    { title: 'Daily Journal Page 3', desc: 'New day with new questions' },
    { title: 'Gratitude Page 2', desc: 'Focus on people in my life' },
    { title: 'Free Writing', desc: 'Open page with optional theme' },
    { title: 'Monthly Reflection', desc: 'Looking back and adjustments' },
  ],
  'recipe-book': [
    { title: 'Introduction', desc: 'Story behind the recipe book and how to use it' },
    { title: 'Recipe 1', desc: 'First recipe with ingredients and instructions' },
    { title: 'Recipe 2', desc: 'Second recipe with tips and variations' },
    { title: 'Recipe 3', desc: 'Third recipe with nutrition info' },
    { title: 'Shopping List', desc: 'Combined shopping list for all recipes' },
    { title: 'Meal Prep Tips', desc: 'Tips for preparation and storage' },
    { title: 'Notes', desc: 'Space for your own adjustments and comments' },
  ],
  'memory-book': [
    { title: 'Cover', desc: 'Beautiful design with title and name' },
    { title: 'About Us', desc: 'Introduction and who the memory book is for' },
    { title: 'Milestone 1', desc: 'First big milestone with photo and text' },
    { title: 'Milestone 2', desc: 'Second important moment' },
    { title: 'Photo Pages', desc: 'Space for photos with captions' },
    { title: 'Letter', desc: 'Personal letter to the future' },
    { title: 'Timeline', desc: 'Visual timeline of important dates' },
  ],
  'travel-planner': [
    { title: 'Trip Overview', desc: 'Destination, dates and travel companions' },
    { title: 'Daily Itinerary', desc: 'Day-by-day plan with activities' },
    { title: 'Packing List', desc: 'Everything you need to pack' },
    { title: 'Budget', desc: 'Travel budget and expense tracking' },
    { title: 'Booking Info', desc: 'Hotel, flights and transport details' },
    { title: 'Restaurants & Tips', desc: 'Local recommendations and tips' },
    { title: 'Memories', desc: 'Space for travel memories and photos' },
  ],
  'fitness-program': [
    { title: 'Program Overview', desc: 'Goals, duration, level and equipment' },
    { title: 'Week 1-2: Foundation', desc: 'Basic exercises and technique' },
    { title: 'Week 3-4: Progression', desc: 'Increased intensity and new exercises' },
    { title: 'Week 5-6: Challenge', desc: 'Advanced variations and supersets' },
    { title: 'Exercise Library', desc: 'Detailed description of all exercises' },
    { title: 'Training Log', desc: 'Track sets, reps and weights' },
    { title: 'Nutrition Tips', desc: 'Nutrition to support training results' },
  ],
  'activity-book': [
    { title: 'Welcome', desc: 'Introduction and how to use the book' },
    { title: 'Creative Task 1', desc: 'Drawing challenge or coloring activity' },
    { title: 'Puzzle', desc: 'Crossword, word search or sudoku' },
    { title: 'Challenge', desc: 'Practical challenge to complete' },
    { title: 'Quiz', desc: 'Fun quiz with questions and answers' },
    { title: 'Creative Task 2', desc: 'Writing task or collage' },
    { title: 'Certificate', desc: 'Diploma for completed activity book' },
  ],
  'reading-journal': [
    { title: 'My Reading List', desc: 'Wishlist of books to read' },
    { title: 'Currently Reading', desc: 'Active reading with notes and page count' },
    { title: 'Book Review', desc: 'Rating, favorite quotes and score' },
    { title: 'Favorite Quotes', desc: 'Collection of the best quotes' },
    { title: 'Reading Log', desc: 'Date, title, pages and reading sessions' },
    { title: 'Annual Summary', desc: 'Year\'s best books and reading statistics' },
  ],
  'pet-journal': [
    { title: 'My Pet', desc: 'Name, breed, birthday and profile' },
    { title: 'Health Log', desc: 'Vet visits, vaccines and medication' },
    { title: 'Daily Log', desc: 'Food, activity and mood' },
    { title: 'Training Diary', desc: 'Commands learned and training sessions' },
    { title: 'Milestones', desc: 'Firsts, birthdays and special moments' },
    { title: 'Memories', desc: 'Photos and stories with your pet' },
  ],
  'pregnancy-journal': [
    { title: 'About Me & Baby', desc: 'Personal info and due date' },
    { title: 'Week by Week', desc: 'Weekly update with symptoms and feelings' },
    { title: 'Ultrasound Photos', desc: 'Space for ultrasound photos with dates' },
    { title: 'Letters to Baby', desc: 'Personal letters written during pregnancy' },
    { title: 'Name Ideas', desc: 'List of favorite names with meanings' },
    { title: 'Hospital Bag', desc: 'Everything needed for the birth' },
    { title: 'Milestones', desc: 'First kick, gender reveal and other moments' },
  ],
};

export const inspirationChips = {
  'carousel': {
    topics: ['5 tips for better sleep', '3 budget planning mistakes', '7 morning routines for productivity', 'Before vs after: Minimalism'],
    audiences: ['Instagram followers', 'Health blog audience', 'Young professionals on social media', 'Visually oriented users'],
  },
  'printable': {
    topics: ['Weekly planner', 'Birthday calendar', 'Reading list for kids', 'Shopping list template'],
    audiences: ['Parents', 'Students', 'Organized people', 'Creative souls'],
  },
  'budget-planner': {
    topics: ['Monthly budget tracking', 'Student budget', 'Debt payoff', 'Household budget'],
    audiences: ['Students on a tight budget', 'Young professionals saving money', 'Families with shared finances', 'Freelancers with uneven income'],
  },
  'meal-planner': {
    topics: ['Weekly dinner plan for families', 'Budget meals', 'High-protein meal plan', 'Vegan weekly plan'],
    audiences: ['Busy parents', 'Fitness enthusiasts', 'Students who cook', 'People who want to eat healthier'],
  },
  'workout-planner': {
    topics: ['30-day home workout', 'Strength program for beginners', '5K running program', 'Yoga routine'],
    audiences: ['Beginners starting to exercise', 'People working out at home', 'Runners in training', 'Women who want to build strength'],
  },
  'goal-workbook': {
    topics: ['90-day goal setting', 'Career plan', 'Personal growth journal', 'Life goal guide'],
    audiences: ['Ambitious professionals', 'People in life transitions', 'Entrepreneurs with quarterly goals', 'Students planning their future'],
  },
  'habit-tracker': {
    topics: ['30-day habit building', 'Morning routine tracker', 'Health and wellness log', 'Mindfulness tracker'],
    audiences: ['People building new habits', 'Busy professionals', 'Students', 'Self-improvement enthusiasts'],
  },
  'business-planner': {
    topics: ['Starting an online store', 'Social media content calendar', 'Freelance project planner', 'E-commerce plan'],
    audiences: ['New entrepreneurs', 'Freelancers', 'Small business owners', 'Content creators'],
  },
  'daily-planner': {
    topics: ['Aesthetic daily planner', 'Time-block planner', 'Work-life balance', 'Student daily planner'],
    audiences: ['Busy professionals', 'Students', 'Work-from-home parents', 'Creative souls'],
  },
  'savings-tracker': {
    topics: ['Emergency savings', 'Vacation savings plan', 'Debt-free journey', 'Monthly savings challenge'],
    audiences: ['Young adults starting to save', 'Families saving for vacation', 'People paying off loans', 'Couples saving for a home'],
  },
  'guide': {
    topics: ['Complete beginner guide to investing', 'How to start an Etsy shop', 'Digital marketing for small businesses', 'Self-care for busy people'],
    audiences: ['Beginners who need step-by-step', 'Small business owners', 'People learning something new', 'DIY enthusiasts'],
  },
  'ebook': {
    topics: ['The ultimate guide to passive income', 'From employee to entrepreneur', 'Healthy food on a budget', '30 days to better habits'],
    audiences: ['Aspiring entrepreneurs', 'Health-conscious readers', 'People seeking financial freedom', 'Self-help book readers'],
  },
  'course-booklet': {
    topics: ['Introduction to photography', 'Personal finance basics', 'Stress management for beginners', 'Digital marketing 101'],
    audiences: ['Course participants and students', 'Beginners in a subject', 'People wanting structured learning', 'Professionals upgrading skills'],
  },
  'lead-magnet': {
    topics: ['5 mistakes everyone makes with budgets', '7 tips for better sleep', 'Free online store checklist', '3 steps to more energy'],
    audiences: ['Potential customers and leads', 'Email subscribers', 'Curious social media followers', 'People seeking quick solutions'],
  },
  'client-guide': {
    topics: ['Before and after wax treatment', 'Tattoo preparation guide', 'Guide for new hair salon clients', 'Skincare after treatment'],
    audiences: ['New clients', 'Clients before first treatment', 'Clients needing aftercare', 'Loyal clients wanting more info'],
  },
  'checklist': {
    topics: ['Moving checklist', 'Wedding planning', 'Travel checklist', 'Business startup'],
    audiences: ['People planning a big event', 'Organization enthusiasts', 'Beginners needing structure', 'Anyone who wants an overview'],
  },
  'journal': {
    topics: ['Gratitude journal', 'Dream diary', 'Stress management reflection journal', 'Morning journal for productivity'],
    audiences: ['People who want to journal daily', 'Self-improvement enthusiasts', 'Creative writers', 'Stressed professionals'],
  },
  'recipe-book': {
    topics: ['Budget meals for students', 'Vegan favorites', 'High-protein meals for fitness', 'Family recipes from grandma'],
    audiences: ['Students who cook', 'Fitness enthusiasts', 'Families with kids', 'Vegans and vegetarians'],
  },
  'memory-book': {
    topics: ['Baby\'s first year', 'Our wedding day', 'Family travel book', 'Memory book for grandpa'],
    audiences: ['New parents', 'Couples getting married', 'Families who travel', 'Grandparents and family'],
  },
  'travel-planner': {
    topics: ['Backpacking in Southeast Asia', 'Family road trip in Europe', 'Weekend trip to Paris', 'Road trip with campervan'],
    audiences: ['Backpackers', 'Families with kids', 'Couples on a romantic trip', 'Adventurous travelers'],
  },
  'fitness-program': {
    topics: ['12-week strength program for beginners', 'Home workout without equipment', 'Half-marathon preparation', 'Yoga and mobility for office workers'],
    audiences: ['Beginners wanting to get in shape', 'People working out at home', 'Runners wanting to improve', 'Office workers with stiff bodies'],
  },
  'activity-book': {
    topics: ['Creative activity book for kids 6-10', 'Mindfulness exercises for adults', 'Team building activities', 'Learning activities for homeschooling'],
    audiences: ['Elementary school kids', 'Adults seeking relaxation', 'Team leaders and HR', 'Parents who homeschool'],
  },
  'reading-journal': {
    topics: ['Reading journal for book lovers', 'Book club diary', '52 books in 52 weeks', 'Child\'s reading journey'],
    audiences: ['Avid readers', 'Book club members', 'Students', 'Parents with reading children'],
  },
  'pet-journal': {
    topics: ['Puppy\'s first year', 'Cat\'s health log', 'Dog owner\'s training diary', 'Pet\'s life book'],
    audiences: ['New dog owners', 'Cat owners', 'Dog training enthusiasts', 'Animal lovers'],
  },
  'pregnancy-journal': {
    topics: ['My pregnancy journey', 'Twin pregnancy diary', 'First baby — complete journal', 'Rainbow pregnancy'],
    audiences: ['First-time pregnant', 'Twin parents', 'Couples expecting', 'Pregnant women wanting to document the journey'],
  },
};
